<div>
  @for (menu of verticalMenus(); track menu.key) {
    @if (menu.items.length > 0) {
      <app-vertical-menu
        [attr.data-test-id]="menu.key + '-vertical-menu'"
        [menuTitle]="menu.title | translate"
        [menuItems]="menu.items"
        [isCollapsed]="isCollapsed"
        (menuItemClicked)="onMenuItemClick($event)"
      ></app-vertical-menu>
    }
  }

  @if (showMobileAccountSection && accountMenuItems().length > 0) {
    <app-vertical-menu
      data-test-id="account-vertical-menu"
      [menuTitle]="'sidebar_menu_account' | translate"
      [menuItems]="accountMenuItems()"
      [isCollapsed]="false"
      (menuItemClicked)="onMenuItemClick($event)"
    ></app-vertical-menu>
  }

  @if (showMobileAccountSection && logoutItem(); as logout) {
    <div class="mobile-logout" data-test-id="mobile-logout-button">
      <a
        ds-button
        [variant]="DsButtonVariants.secondary"
        [icon]="Icons.ArrowRightFromBracket"
        [routerLink]="logout.routerLink"
        (click)="onMenuItemClick(logout)"
      >
        {{ logout.label | translate }}
      </a>
    </div>
  }
</div>
